import { createContext } from 'react'

const UserInfoContext = createContext()

export default UserInfoContext
